import { useState } from 'react';

export function useOverlayModal(initialState) {
  const [open, setOpen] = useState(initialState);
  return [open, setOpen];
}
